import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TrueGrit} from "../TrueGrit";
import {TrueGritStatics} from "../TrueGritStatics";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";

/**
 * Created by Jerker Nord on 2021-11-23.
 */

export class TrueGritReelSplitView extends PIXI.Container implements StageLayer {

    private _reelSplitAnimation:TimelineSprite;

    private static REEL_SPLIT_OFFSET:PIXI.Point = new PIXI.Point(86, -120);

    constructor() {
        super();
        this.name = "TrueGritReelSplitView";
        this.init();
    }

    private init() {
        this._reelSplitAnimation = new TimelineSprite(TrueGrit.assetLoader.getTextures("Z/Zattention/ZAttention_"));
        this._reelSplitAnimation.anchor.set(0.5, 0.5);
        this._reelSplitAnimation.visible = false;
        this.addChild(this._reelSplitAnimation);
        this.onResize();
    }

    onResize():void {
        this.position = TrueGritStatics.MAIN_REELS_VIEW_POSITION;
        if(!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + NolimitApplication.screenBounds.top) / 2;
        }
    }

    public getReelSplitAnimation(symbolPosition:PIXI.Point):gsap.core.Timeline {
        this._reelSplitAnimation.position.x = symbolPosition.x + TrueGritStatics.BOTTOM_REEL_VIEW_POSITION.x + TrueGritReelSplitView.REEL_SPLIT_OFFSET.x;
        this._reelSplitAnimation.position.y = symbolPosition.y + TrueGritStatics.BOTTOM_REEL_VIEW_POSITION.y + TrueGritReelSplitView.REEL_SPLIT_OFFSET.y;
        return this._reelSplitAnimation.getAnimationAutoShowHide();
    }
}